
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetorajshthaninnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Rajasthan Innova Crysta Rental',
        heading: 'Meghana Cab : Pune to Rajasthan Innova Crysta Rental',
        headingDescription: 'Meghana Cab offers Pune to Rajasthan Innova Crysta Rental, delivering a luxurious, comfortable, and highly flexible travel solution tailored for Pune’s vibrant eastern suburb. Whether it’s local errands, sightseeing, airport transfers, corporate events, or outstation trips, our Innova Crysta vehicles are equipped with plush leather interiors, generous legroom, ample luggage capacity, and smooth air-conditioned comfort. With experienced and courteous chauffeurs, you get reliable door-to-door service directly from Viman Nagar—including locations like Koregaon Park, Kharadi bypass, or near the airport . Choose from hourly or full-day packages, one-way or round-trip options, and enjoy GPS tracking, transparent booking, and 24/7 customer support from Meghana Cab—ensuring your ride is always smooth, stylish, and tailored to your needs.',


        top: 'Top Places to Visit in Rajasthan with Meghana Cab',

"topPlaces": [
  {
    "title": "Amber Fort (Jaipur)",
    "description": "A majestic hilltop fort-palace built in 1592 by Raja Man Singh I, blending Rajput and Mughal architecture. Highlights include the mirror-studded Sheesh Mahal, Diwan‑e‑Aam, Diwan‑e‑Khas, and scenic views over Maota Lake. Part of the UNESCO‑listed Hill Forts of Rajasthan."
  },
  {
    "title": "Mehrangarh Fort (Jodhpur)",
    "description": "One of India's largest forts, towering 410 ft above the Blue City. It houses palaces, museums, courtyards, and galleries, offering panoramic views and a vivid cultural experience of Rajput grandeur."
  },
  {
    "title": "City Palace & Hawa Mahal (Jaipur)",
    "description": "A sprawling complex of palaces, courtyards, and museums with Mughal‑Rajput design, alongside the iconic lattice‑façade of the Hawa Mahal—originally built for royal women to view street life."
  },
  {
    "title": "Jaisalmer Fort",
    "description": "The Golden City’s living fort, made from honey-gold sandstone in 1156 AD. Inside its ramparts are Jain temples, ornate havelis, shops, and residences—creating a desert-city experience like no other."
  },
  {
    "title": "City Palace & Lake Pichola (Udaipur)",
    "description": "Palatial complex overlooking the iconic Lake Pichola, with jagmandirs and romantic sunset boat rides adding timeless charm to Udaipur’s lake-city aura."
  },
  {
    "title": "Kumbhalgarh Fort",
    "description": "Known as the ‘Great Wall of India’, this 15th‑century fortress boasts a 36 km-long boundary wall amid the Aravalli Hills and is the birthplace of Maharana Pratap."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "The largest fort in India, set atop a 180 m hill and spread over 280 ha. It includes palaces, temples, water bodies, and the iconic Vijay Stambha—symbolizing Rajput resilience."
  },
  {
    "title": "Bundi",
    "description": "A quieter, authentic Rajasthan town known for its ornate stepwells, lake-front palaces, and vibrant murals—often referred to as an offbeat heritage gem."
  },
  {
    "title": "Mount Abu",
    "description": "Rajasthan’s only hill station, at 1,220 m above sea level, offering respite from the heat with lush trails, Nakki Lake, and the exquisite Dilwara Jain temples."
  },
  {
    "title": "Keoladeo Ghana National Park (Bharatpur)",
    "description": "A UNESCO World Heritage bird sanctuary home to over 350 species of resident and migratory birds, set in a former royal duck-hunting reserve—perfect for wildlife and birding enthusiasts."
  }
],

  "services": [
    {
      "name": "Pune to Rajasthan Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab for your long-distance journey from Pune to Rajasthan. Enjoy a comfortable, safe, and scenic ride through multiple states with professional chauffeurs and luxury interiors."
    },
    {
      "name": "One Way Innova Crysta Pune Rajasthan",
      "description": "Opt for our affordable one-way Innova Crysta cab service for Pune to Rajasthan travel. Ideal for travelers who prefer flexibility without return trip commitments."
    },
    {
      "name": "Round Trip Innova Crysta Pune Rajasthan",
      "description": "Choose our round trip Innova Crysta cab option for a hassle-free journey with flexible return timings, ensuring seamless travel between Pune and Rajasthan."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Rajasthan",
      "description": "Travel in cool comfort with our fully air-conditioned Innova Crysta taxis, perfect for the long drive from Pune to Rajasthan."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Rajasthan",
      "description": "Our courteous, experienced chauffeurs ensure a safe and pleasant journey, taking care of all driving details while you relax on the way to Rajasthan."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Rajasthan",
      "description": "Book a private Innova Crysta taxi exclusively for your group or family, offering privacy, flexibility, and comfort during your Rajasthan trip."
    },
    {
      "name": "Online Booking Innova Crysta Pune Rajasthan",
      "description": "Easily book your Pune to Rajasthan Innova Crysta cab online with instant confirmation, transparent pricing, and customizable pickup and drop options."
    },
    {
      "name": "Rajasthan Tour Innova Crysta",
      "description": "Explore Rajasthan’s top attractions like Jaipur, Udaipur, Jodhpur, and more with a reliable Innova Crysta cab, perfect for guided tours or multi-city itineraries."
    },
    {
      "name": "Jaipur Trip Innova Crysta Pune",
      "description": "Plan your visit to the Pink City with our dedicated Pune to Jaipur Innova Crysta cab service, ensuring a comfortable and punctual trip."
    },
    {
      "name": "Udaipur Innova Crysta Cab Pune",
      "description": "Travel in style from Pune to the City of Lakes, Udaipur, with our premium Innova Crysta cab service, featuring spacious interiors and courteous drivers."
    },
    {
      "name": "Business Travel Innova Crysta Rajasthan",
      "description": "Ideal for corporate trips, our Innova Crysta cabs offer professional, punctual service with added comfort for your business travel needs across Rajasthan."
    },
    {
      "name": "Comfortable Innova Crysta Taxi Pune Rajasthan",
      "description": "Enjoy a smooth and relaxing ride in our well-maintained Innova Crysta taxis, designed to provide comfort on the long journey to Rajasthan."
    },
    {
      "name": "Budget Innova Crysta Rental Pune Rajasthan",
      "description": "Avail our budget-friendly Innova Crysta rental options without compromising on quality or comfort for your Pune to Rajasthan travel."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our taxis are specially equipped and maintained for long-distance drives, providing reliability and comfort over extended routes like Pune to Rajasthan."
    },
    {
      "name": "Premium Cab Hire Pune Rajasthan",
      "description": "Upgrade your trip with our premium Innova Crysta hire, featuring luxury interiors, captain seats, and VIP-level service for an elite travel experience."
    }
  ],
  "tableData": [
    ["Pune to Rajasthan Innova Crysta Cab Booking", "One Way Innova Crysta Pune Rajasthan"],
    ["Round Trip Innova Crysta Pune Rajasthan", "AC Innova Crysta Taxi Pune Rajasthan"],
    ["Chauffeur Driven Innova Crysta Pune Rajasthan", "Private Innova Crysta Taxi Pune Rajasthan"],
    ["Online Booking Innova Crysta Pune Rajasthan", "Rajasthan Tour Innova Crysta"],
    ["Jaipur Trip Innova Crysta Pune", "Udaipur Innova Crysta Cab Pune"],
    ["Business Travel Innova Crysta Rajasthan", "Comfortable Innova Crysta Taxi Pune Rajasthan"],
    ["Budget Innova Crysta Rental Pune Rajasthan", "Long Distance Innova Crysta Taxi"],
    ["Premium Cab Hire Pune Rajasthan", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Innova Crysta Rental from Pune to Rajasthan",
    "WhyChoosedescription": "Travel from Pune to Rajasthan in unmatched comfort with our premium Innova Crysta car rental. Whether you're visiting Jaipur, Udaipur, Jodhpur, or other cities, enjoy a smooth and safe journey over 1,000+ kilometers of diverse landscapes."
  },
  {
    "WhyChooseheading": "Comfortable Ride for Long-Distance Journeys",
    "WhyChoosedescription": "Our Innova Crysta vehicles are designed for long hauls with reclining seats, dual AC, ample legroom, and generous luggage space—making them ideal for family trips, group travel, or business tours to Rajasthan."
  },
  {
    "WhyChooseheading": "Professional Drivers with Long-Route Experience",
    "WhyChoosedescription": "Our trained chauffeurs are experienced in inter-state travel and well-versed with routes through Maharashtra, Gujarat, and Rajasthan. They ensure safe driving, timely arrivals, and help you plan rest stops efficiently."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Fully Maintained Fleet",
    "WhyChoosedescription": "Each vehicle is sanitized before departure and undergoes regular mechanical inspections. You’ll ride in a well-maintained Innova Crysta equipped for long-distance comfort, safety, and convenience."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans & Multi-Day Rentals",
    "WhyChoosedescription": "We offer custom itineraries and multi-day booking options. Whether it’s a heritage tour, pilgrimage, wedding trip, or business meeting, your Pune to Rajasthan plan can be customized to your schedule."
  },
  {
    "WhyChooseheading": "All-Inclusive Transparent Pricing",
    "WhyChoosedescription": "Our long-distance packages cover tolls, state taxes, fuel, and driver allowance. You’ll receive a clear, upfront quote with no hidden charges—perfect for stress-free budgeting on extended travel."
  },
  {
    "WhyChooseheading": "Ideal for Tourism, Corporate Visits, or Family Trips",
    "WhyChoosedescription": "Whether you're exploring Rajasthan’s palaces and forts, attending a destination wedding, or traveling for corporate purposes, our Innova Crysta provides the space, luxury, and reliability your trip demands."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance & Route Planning Support",
    "WhyChoosedescription": "Our dedicated customer care team is available round-the-clock to assist with bookings, multi-city plans, or any last-minute adjustments—making your outstation travel from Pune to Rajasthan seamless."
  }
]






















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta from Pune to Rajasthan?",
        answer: "To book, call Meghana Cab at +91 9075462128 or visit our website for instant online booking."
    },
    {
        question: "What is the approximate distance and travel time from Pune to Rajasthan?",
        answer: "The distance varies by city, but it's approximately 1,000 to 1,200 km and takes around 18 to 22 hours by road."
    },
    {
        question: "Is Innova Crysta suitable for a long road trip to Rajasthan?",
        answer: "Yes, the Innova Crysta is ideal for long journeys due to its spacious interiors, powerful engine, and comfortable ride."
    },
    {
        question: "Can I book the cab for a round trip from Pune to Rajasthan?",
        answer: "Yes, both one-way and round-trip packages are available for Rajasthan travel."
    },
    {
        question: "How many passengers can travel in the Innova Crysta?",
        answer: "The Innova Crysta seats 6 to 7 passengers comfortably with ample space for luggage."
    },
    {
        question: "Are the drivers experienced with long-distance routes like Rajasthan?",
        answer: "Yes, our drivers are highly experienced and familiar with inter-state and long-distance road travel."
    },
    {
        question: "Are your vehicles sanitized before long journeys?",
        answer: "Yes, all vehicles are thoroughly cleaned and sanitized before every trip for your safety."
    },
    {
        question: "What is included in the Pune to Rajasthan cab fare?",
        answer: "The fare includes fuel, driver charges, and tolls. Parking fees or extended stopovers may attract additional charges."
    },
    {
        question: "Can I request sightseeing or overnight stops on the way?",
        answer: "Yes, we can customize your itinerary with sightseeing and hotel stops on request."
    },
    {
        question: "What payment options are available for Rajasthan bookings?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Dinesh Solanki',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We hired an Innova Crysta for our family trip from Pune to Jaipur. The car was in excellent condition and the driver was very cooperative.”',
    },
    {
        name: 'Ms. Kiran Rathore',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Amazing long-distance service by Meghana Cab. Smooth ride to Udaipur and back with multiple stopovers — well managed!”',
    },
];
































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const puneRajasthanInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Rajasthan Innova Crysta Rental",
  "description": "Book chauffeur-driven Innova Crysta cabs from Pune to Rajasthan for tours, business travel, and outstation trips. Reliable, AC, and comfortable taxi service for Jaipur, Udaipur, and other destinations.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Cab Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Rajasthan"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-rajasthan-innova-crysta-cab"
  }
};







    return (
        <div>


<Helmet>
  <title>Pune to Rajasthan Innova Crysta Cab | Outstation Taxi Booking</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cab from Pune to Rajasthan for Udaipur, Jaipur, and business or family travel. AC, reliable, and premium long-distance taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Rajasthan Innova Crysta Cab Booking, One Way Innova Crysta Pune Rajasthan, Round Trip Innova Crysta Pune Rajasthan, AC Innova Crysta Taxi Pune Rajasthan, Chauffeur Driven Innova Crysta Pune Rajasthan, Private Innova Crysta Taxi Pune Rajasthan, Online Booking Innova Crysta Pune Rajasthan, Rajasthan Tour Innova Crysta, Jaipur Trip Innova Crysta Pune, Udaipur Innova Crysta Cab Pune, Business Travel Innova Crysta Rajasthan, Comfortable Innova Crysta Taxi Pune Rajasthan, Budget Innova Crysta Rental Pune Rajasthan, Long Distance Innova Crysta Taxi, Premium Cab Hire Pune Rajasthan"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneRajasthanInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/12.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetorajshthaninnovacrysta;